/* eslint-disable no-restricted-imports */
import * as React from 'react';
import { Button as MuiButton } from '@material-ui/core';
import { ButtonProps as MuiButtonProps } from '@material-ui/core/Button';
import {
  buttonSizeStyles,
  buttonVariantStyles,
  commonStyles,
  iconSizes,
} from 'bento/Button/buttonCssDefs';

export type ButtonColor = 'danger' | 'primary' | 'subtle' | 'success' | 'contrast' | 'internal';

export interface ButtonProps
  extends Pick<
    MuiButtonProps,
    Exclude<keyof MuiButtonProps, 'color' | 'disableRipple' | 'disableTouchRipple'>
  > {
  color?: ButtonColor;
  component?: React.ElementType;
  to?: string;
  target?: string;
  rel?: string;
}

/**
 * Use `Button` to place a button on the ui
 *
 * ```js
 * import { Button } from 'bento';
 * ```
 * @deprecated Deprecated — use pantry Button instead.
 * @see https://docs.tocktix.com/pantry?path=/docs/components-button--docs
 * Migration: Replace Button with the pantry Button component.
 */
export const Button: React.FunctionComponent<React.PropsWithChildren<ButtonProps>> = ({
  color = 'primary',
  variant = 'contained',
  children,
  size = 'medium',
  className,
  ...rest
}) => {
  return (
    <MuiButton
      className={className}
      variant={variant}
      css={[commonStyles(color), buttonVariantStyles[variant], buttonSizeStyles[size], iconSizes]}
      size={size}
      {...rest}
    >
      {children}
    </MuiButton>
  );
};
